    <form [formGroup]="group" ngClass="customtextarea" >
            <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [customMenuRef]="customMenu"> </ngx-editor-menu>
            <ngx-editor
              [editor]="editor"
              outputFormat="html"
              [placeholder]="config.COLUMNDESC"
              [(ngModel)]="html"
              [disabled]="config.ISREADONLY==1?true:false"
              [formControlName]="config.COLUMNNAME"
              (blur)="bluring($event)"
            ></ngx-editor>
    </form>

    <ng-template #customMenu>
        <div class="NgxEditor__Seperator"></div>
        <span class="tem-field-suffix">
            <button *ngIf="showBuscaDados" tabindex="-1" nz-button nzType="text" nzSize="small" aria-label="Buscar do Dados" (click)="dynaServices.getDataFromTable(group, config.COLUMNNAME,entityName, null, null, 'text');editing()" nz-tooltip="Buscar do Dados">
                <nz-icon nzType="rollback"></nz-icon>
            </button>
            <button nz-button nzType="text" nzSize="small" *ngIf="toolTipText!=null" [tooltip]="toolTipText">
                <nz-icon nzType="question-circle"></nz-icon>
            </button>
            <form-field-properties [information]="config" [entityDesc]="entityDesc" [entityName]="entityName" *ngIf="canConfig" [row]="row" ></form-field-properties>
        </span>
    </ng-template>